<!-- Navigation Drawer for mobile view -->
<div [@slideInOut]="menuState" class="sidebar">
  <ui5-tree mode="SingleSelect" (item-click)="handleNavigationDrawerSelectionChange($event)">
    <div class="sidebar-header" slot="header">
      <a routerLink="/settings" >
        <img src="./assets/images/itu_logo_HighRes.png" (click)="closeNavigatioDrawer()" />
      </a>
      <ui5-button class="icons" icon="navigation-left-arrow" (click)="closeNavigatioDrawer()"></ui5-button>
    </div>
    <ui5-tree-item
      expanded
      *ngFor="let item of navigationItems"
      text="{{ item.name }}"
      id="{{ item.id }}"
      [selected]="item.selected"
    >
      <ui5-tree-item
        *ngFor="let child of item.children"
        id="{{ child.id }}"
        text="{{ child.name }}"
        icon="{{ child.icon }}"
        [selected]="child.selected"
      ></ui5-tree-item>
    </ui5-tree-item>
  </ui5-tree>
</div>

<!-- Toast Message -->
<ui5-toast #toastRef [ngClass]="{'success': message?.design === 'Success', 'error': message?.design === 'Error'}"
  duration="{{message?.duration}}" placement="{{message?.placement}}">
  {{message?.text}}
</ui5-toast>

<!-- App Layout - TableContainer and SideNavigation hidden on mobile view -->
<div class="app-layout">
  <app-header class="header-section"></app-header>

  <ui5-tabcontainer class="tab-section" fixed collapsed (tab-select)="handleTabSelectionChange($event)">
    <ui5-tab
      *ngFor="let item of navigationItems"
      id="{{ item.id }}"
      text="{{ item.name }}"
      [selected]="item.selected"
    ></ui5-tab>
    <ui5-tab [selected]="!isAnyTabSelected"></ui5-tab>
  </ui5-tabcontainer>

  <ng-container *ngIf="isAnyTabSelected; else noneTabSelected">
    <ui5-side-navigation class="side-navigation-section" (selection-change)="handleSideNavigationSelectionChange($event)">
      <ng-container *ngFor="let item of navigationItems">
        <ng-container *ngIf="item.selected">
          <ui5-side-navigation-item
            *ngFor="let child of item.children"
            id="{{ child.id }}"
            text="{{ child.name }}"
            icon="{{ child.icon }}"
            [selected]="child.selected"
          ></ui5-side-navigation-item>
        </ng-container>
      </ng-container>
    </ui5-side-navigation>
  </ng-container>

  <ng-template #noneTabSelected>
    <div class="side-navigation-section no-content">
      <b class="pt-6">Select a tab to see the content</b>
    </div>
  </ng-template>

  <div class="content-section">
    <router-outlet></router-outlet>
  </div>
</div>
